import dayjs from "dayjs";
import React from "react";
import Button from "../../../../components/ui/Button/Button";
import Modal from "../../../../components/ui/Modal/Modal";
import {
  convertDateToDateTime,
  convertSecondsToDateTime,
} from "../../../../helper/formatDate/formate-date";
import { Form } from "../../../../utils/Form/Form";
import FieldBox from "../../../../utils/Form/ui/FieldBox";

const Instruction = (props) => {
  const {
    showInstructions,
    handleImageUpload,
    imagePreview,
    onCancelAdd,
    onSubmit,
    imageName,
    selectedCategory,
    isEditDetail,
    handleToggleEdit,
    handleDeleteCategory,
    isViewDetail,
    catName,
    setCatName,
  } = props;

  const isModeAdd = Object.values(selectedCategory).every(
    (val) => val === null || val === "" || val === undefined
  );

  const onChangeCatName = (e) => {
    setCatName(e.target.value);
  };

  return (
    <div className="ml-8 text-[12px] text-title-grey w-full">
      {showInstructions && (
        <div className="space-y-2">
          <h1 className="font-bold">※ 사용 방법 안내</h1>
          <p>1. '카테고리 설정영역에서 카테고리를 선택해주세요.</p>
          <p>
            2. 선택하면, 이미 등록 된 ONEDAY Mall 카테고리 정보를 확인 할 수
            있습니다.
          </p>
          <p>
            3. 카테고리 추가가 필요할 경우, 하단에 카테고리 추가를 선택해주세요.
          </p>
          <p>4. ONEDAY Mall 카테고리 이미지 : 병원APP에서만 반영됩니다.</p>
          <p>5. 카테고리명 : 병원WEB(PC), 병원APP에 모두 반영됩니다.</p>
          <p>
            6. 이미 해당 카테고리에 상품 판매정보가 연동될 경우, 카테고리 삭제가
            불가능하며, 연동 정보가 없을 때 삭제 가능합니다.
          </p>
          <p>
            7. 현재의 화면은 카테고리 설정에서 전체를 눌렀을 때 나오는
            화면입니다.
          </p>
        </div>
      )}
      {!showInstructions &&
        (isViewDetail && !isEditDetail ? (
          <div>
            <div className="flex items-center">
              <div className="w-1/2">
                <FieldBox splitted splittedWidth="w-[50%]" label="등록일시">
                  <span className="p-2 text-black">
                    {selectedCategory?.createdAt
                      ? dayjs(selectedCategory?.createdAt).format(
                          "YYYY-MM-DD HH:mm"
                        )
                      : "-"}
                  </span>
                </FieldBox>
              </div>
              <div className="w-1/2">
                <FieldBox
                  splitted
                  splittedWidth="w-[50%]"
                  label="등록된 상품 수량"
                >
                  <span className="p-2 text-black">
                    {selectedCategory?.productQnt}
                  </span>
                </FieldBox>
              </div>
            </div>
            <FieldBox unSplittedWidth="w-[19.4%]" label="카테고리명">
              <span className="p-2 text-black">{selectedCategory?.name}</span>
            </FieldBox>
            <FieldBox unSplittedWidth="w-[19.4%]" label="APP 카테고리 이미지">
              <span className="p-2 text-black">
                {selectedCategory?.img.split("/").pop()}
              </span>
            </FieldBox>
            <FieldBox unSplittedWidth="w-[19.4%]" label="이미지 미리보기">
              <p className="text-title-grey text-[12px]">
                ※ 병원APP ONEDAY Mall 카테고리 이미지 영역 기준으로 등록
                이미지는 리사이징 됩니다.
              </p>
              <div>
                <div className="w-[75px] border mt-2 h-[70px]">
                  <img
                    src={selectedCategory?.img}
                    className="object-fit w-full h-full"
                    alt="Preview"
                  />
                </div>
              </div>
            </FieldBox>
            <FieldBox
              unSplittedWidth="w-[19.4%]"
              label="자동주문 가능여부"
              isLast
            >
              <span className="p-2 text-black">
                {selectedCategory?.isAutoOrderAvailable ? "가능" : "불가능"}
              </span>
            </FieldBox>

            <div className="flex justify-end text-sm mt-6">
              {selectedCategory?.name === "Fixture" ? (
                <Button
                  isDisabled={true}
                  width="w-[7rem]"
                  paddingButton="p-[7px]"
                  type="button"
                  onClick={(e) => e.preventDefault()}
                  text="카테고리 삭제"
                />
              ) : (
                <Modal
                  description={
                    <span>
                      해당 카테고리를 삭제하시겠습니까?{" "}
                      <span className="text-[#B70000] underline">
                        등록된 상품이 없는 경우에 한하여
                      </span>{" "}
                      삭 제가 가능합니다. 병원APP/WEB에 연동된 정보도 함께
                      삭제됩니다.
                    </span>
                  }
                  onSubmit={() => handleDeleteCategory(selectedCategory?.id)}
                >
                  <Button
                    type="button"
                    width="w-[7rem]"
                    paddingButton="p-[7px]"
                    onClick={(e) => e.preventDefault()}
                    text="카테고리 삭제"
                  />
                </Modal>
              )}
              <Button
                onClick={handleToggleEdit}
                width="w-[7rem]"
                paddingButton="p-[7px]"
                type="button"
                text="정보 변경"
                primary
              />
            </div>
          </div>
        ) : (
          <Form
            onSubmit={onSubmit}
            options={{
              defaultValues: {
                name: selectedCategory?.name,
                img: selectedCategory?.img,
                isAutoOrderAvailable: selectedCategory?.isAutoOrderAvailable,
              },
            }}
          >
            {({ register, watch }) => {
              const formEmpty = catName === "" || imageName === "";

              return (
                <>
                  <div className="flex h-10 ">
                    <div className="text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey w-[17%] items-center flex pl-3">
                      카테고리명
                    </div>
                    <div className="w-[83%]">
                      <input
                        placeholder="카테고리명을 입력해주세요"
                        className="border w-full placeholder:text-[12px] h-10 text-black text-[10px] outline-none pl-4"
                        name="name"
                        value={catName}
                        defaultValue={selectedCategory?.name}
                        {...register("name")}
                        onChange={onChangeCatName}
                      />
                    </div>
                  </div>
                  <div className="flex">
                    <div className="text-[12px] border h-10 border-r-0 border-t-0 text-black border-primary-grey bg-input-grey w-[17%] items-center flex pl-3">
                      APP 카테고리 이미지
                    </div>
                    <div className="w-[83%] h-10 flex border text-[12px] p-1 border-t-0">
                      <label
                        className={`flex justify-center items-center cursor-pointer bg-gradient-to-b ml-2.5 from-white via-primary-white to-background-grey border border-button-grey w-20 text-black text-[12px] rounded-[4px]`}
                        htmlFor="imageInput"
                      >
                        파일선택
                      </label>
                      <input
                        id="imageInput"
                        type="file"
                        className="hidden"
                        onChange={handleImageUpload}
                      />
                      <p className="flex pl-2 items-center text-[12px] text-black">
                        {(imageName ||
                          selectedCategory?.img?.split("uploads/")[1]) ??
                          "업로드 파일 없음"}
                      </p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="text-[12px] border  border-r-0 border-t-0 text-black border-primary-grey bg-input-grey w-[17%] items-center flex pl-3">
                      이미지 미리보기
                    </div>
                    <div className="w-[83%] px-4 py-2.5 border text-[12px] border-t-0">
                      <p className="text-title-grey text-[12px]">
                        ※ 병원APP ONEDAY Mall 카테고리 이미지 영역 기준으로 등록
                        이미지는 리사이징 됩니다.
                      </p>
                      <div>
                        {imagePreview ? (
                          <div className="w-[75px] border mt-2 h-[70px]">
                            <img
                              src={imagePreview}
                              className="object-fit w-full h-full"
                              alt="Preview"
                            />
                          </div>
                        ) : isModeAdd ? (
                          <div className="border mt-2 text-title-grey px-0.5 w-[85px] bg-backdrop-grey border-drop-grey h-[85px] text-center pt-4 text-[8px]">
                            <p>미리보기</p>
                            <p>‘파일선택’에서</p>
                            <p>등록/수정 가능합니다.</p>
                          </div>
                        ) : (
                          <div className="w-[75px] border mt-2 h-[70px]">
                            <img
                              src={selectedCategory?.img}
                              className="object-fit w-full h-full"
                              alt="Preview"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="text-[12px] border h-10 border-r-0 border-t-0 text-black border-primary-grey bg-input-grey w-[17%] items-center flex pl-3">
                      자동주문 가능여부
                    </div>
                    <div className="w-[83%] h-10 flex border text-[12px] p-4 border-t-0">
                      <div className="flex items-center">
                        <input
                          type="checkbox"
                          className="mr-2 accent-black"
                          {...register("isAutoOrderAvailable")}
                        />
                        <label htmlFor="autoOrder">자동주문</label>
                      </div>
                    </div>
                  </div>
                  <div className="text-[11px] mt-3">
                    <p>※ 안내사항</p>
                    <p>
                      1. ONEDAY Mall 카테고리 이미지 : 병원APP에서만 반영됩니다.
                    </p>
                    <p>
                      2. 카테고리명 : 병원WEB(PC), 병원APP에 모두 반영됩니다.
                    </p>
                    <p>
                      3. 이미 해당 카테고리에 상품 판매정보가 연동될 경우,
                      카테고리 삭제가 불가능하며, 연동 정보가 없을 때 삭제
                      가능합니다.
                    </p>
                    <p>
                      4. 자동주문 가능여부 : 병원회원이 해당 카테고리 상품에
                      대해 위험재고수량, 자동주문수량을 설정 할 수 있습니다.
                    </p>
                  </div>
                  <div className="flex justify-end text-sm mt-6">
                    <Modal
                      description={
                        <span>
                          입력을 취소하시겠습니까? 입력한 정보는 저장되지
                          않습니다.{" "}
                        </span>
                      }
                      onSubmit={onCancelAdd}
                    >
                      <Button
                        type="button"
                        width="w-[7rem]"
                        paddingButton="p-[7px]"
                        onClick={(e) => e.preventDefault()}
                        text="입력취소"
                      />
                    </Modal>
                    <Modal
                      description={
                        <div className="text-xs mx-2">
                          {isModeAdd ? (
                            <>
                              {" "}
                              <p>입력한 정보로 카테고리를 추가하시겠습니까?</p>
                              <p className="mt-1">
                                등록 된 카테고리는 병원APP/WEB에 바로
                                연동됩니다.
                              </p>
                            </>
                          ) : (
                            <>
                              <p>
                                입력한 정보로 카테고리의 정보를
                                변경하시겠습니까?
                              </p>
                              <p className="mt-1">
                                변경 된 카테고리는 병원APP/WEB에 바로 업데이트
                                됩니다.{" "}
                              </p>
                            </>
                          )}
                        </div>
                      }
                      onSubmit={() => onSubmit(watch())}
                    >
                      <Button
                        type="button"
                        // onClick={(e) => e.preventDefault()}
                        width="w-[7rem]"
                        paddingButton="p-[7px]"
                        // disabled={formEmpty}
                        // isDisabled={formEmpty}
                        text={isModeAdd ? "등록완료" : "변경완료"}
                        primary
                      />
                    </Modal>
                  </div>
                </>
              );
            }}
          </Form>
        ))}
    </div>
  );
};

export default Instruction;
